class VariantSelects extends HTMLElement {
  connectedCallback() {
    this.variants = [];
    try { this.variants = JSON.parse(this.querySelector('[data-variants]').textContent); } catch(e) {}
    this.variantInput = this.querySelector('[data-variant-id]');
    this.addEventListener('change', this._onChange.bind(this));
  }

  _formatDisplay(value, section) {
    let text = String(value || '').trim();
    if (section?.classList.contains('v3-section--variant-color')) {
      text = text.split('-')[0];
    }
    return text.toUpperCase();
  }

  _onChange(e) {
    if (!e.target.matches('input[type="radio"]')) return;

    // Update label
    const fieldset = e.target.closest('.v3-section');
    if (fieldset) {
      const val = fieldset.querySelector('[data-selected-value]');
      if (val) val.textContent = this._formatDisplay(e.target.value, fieldset);
    }

    // Find variant
    const selected = {};
    this.querySelectorAll('input[type="radio"]:checked').forEach(i => {
      selected[i.dataset.optionPosition] = i.value;
    });
    const variant = this.variants.find(v => v.options.every((val, i) => selected[i + 1] === val));

    if (variant) {
      this.variantInput.value = variant.id;
      if (this.dataset.updateUrl === 'true') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }

    document.dispatchEvent(new CustomEvent('product:variant:change', {
      detail: {
        variant: variant || null,
        featuredMediaId: variant && variant.featured_media ? variant.featured_media.id : null
      }
    }));
  }
}
customElements.define('variant-selects', VariantSelects);
